(() => {
  if (window.__thbCommerceCardGuard) return;
  window.__thbCommerceCardGuard = true;
  const pending = new WeakSet();
  const componentFor = target => target instanceof Element ? target.closest('[data-commerce-card] product-form-component') : null;
  document.addEventListener('submit', event => {
    const component = componentFor(event.target);
    if (!component || !customElements.get('product-form-component')) return;
    if (pending.has(component)) {event.preventDefault(); event.stopImmediatePropagation(); return;}
    pending.add(component);
    const error = component.querySelector('[ref="addToCartTextError"]');
    if (error) {error.classList.add('hidden'); error.textContent = '';}
    queueMicrotask(() => {if (!component.hasAttribute('aria-busy')) pending.delete(component);});
  }, true);
  document.addEventListener('shopify:cart:lines-update', event => {
    const component = componentFor(event.target);
    if (!component || !event.promise) return;
    pending.add(component); component.setAttribute('aria-busy', 'true');
    const button = component.querySelector('[ref="addToCartButton"]');
    if (button) button.disabled = true;
    const finish = () => {pending.delete(component); component.removeAttribute('aria-busy'); if (button?.isConnected) button.disabled = false;};
    event.promise.then(finish, finish);
  });
  document.addEventListener('shopify:cart:error', event => {
    const component = componentFor(event.target);
    if (!component) return;
    const card = component.closest('[data-commerce-card]');
    const message = event.detail?.description || event.error || card.dataset.errorMessage;
    const error = component.querySelector('[ref="addToCartTextError"]');
    if (error) {error.textContent = typeof message === 'string' ? message : card.dataset.errorMessage; error.classList.remove('hidden');}
    const status = component.querySelector('[ref="liveRegion"]');
    if (status) status.textContent = error?.textContent || card.dataset.errorMessage;
  });
})();
